import {CartItemType, CartItemWithProduct, ProductClipType} from "../types/index";
import {Link} from "react-router";
import AmountInput from "./amount-input.tsx";
import ProdInfo from "./prod-info.tsx";
import LeadTimePriceInput from "./lead-time-price-input.tsx";
import {PRODUCT_TYPE} from "../constants.ts";
import UploadImages from "./upload-images";
import { useState} from "react";
import useCart from "../pages/cart/useCart.ts";
import { useAppState } from "../context/index.ts";
import { LeadTimePriceType } from "../types";



export const CartTable = ({cartItems}: { cartItems: CartItemWithProduct[] }) => {

    const {updateCartItem, removeFromCart} = useCart();
    const [cartItemToUpload, setCartItemToUpload] = useState<CartItemType | undefined>(undefined);
    const [leadTimePrices] = useAppState<LeadTimePriceType[]>('leadTimePrices', []);
    

    const productToUpload = cartItems.find(c => c.cartItem.id === cartItemToUpload?.id)?.product;
    return (
        <>
            <div className="xtable xtable_cart">

                {cartItems.map(({cartItem, product}, index) => {


                    return <div key={index} className={`xtable__tr${!product.isAvailable ? ' m-notavailable' : ''}`}>


                        <div className="xtable__td">

                            {product && product.images.length > 0 &&
                                <Link to={`/catalog/product/${product.slug}`} className="xtable__preview">
                                    <picture className="xtable__preview-pic">
                                        <img className="xtable__preview-pic-img" src={`/api/media/${product.images[0].image}?s=s`} alt={product.name}
                                             loading="lazy"/>
                                    </picture>
                                </Link>
                            }
                        </div>

                        <div className="xtable__td xtable__cart-prodinfo">
                            <Link to={`/catalog/product/${product.slug}`} className="xtable__name">{product.name}</Link>
                            <div className="xtable__price-row">
                                <span className="xtable__price">${product.price}</span>

                                {product.type === PRODUCT_TYPE.CLIP && product.clipProperties && Object.keys(product.clipProperties).length > 0 && (
                                        <ProdInfo {...product.clipProperties}/>
                                    )}
                            </div>
                            <div className={`xtable__status m-${product.isAvailable ? 'available' : 'notavailable'}`}>
                                {product.isAvailable ? 'Available' : 'Not available'}
                            </div>
                        </div>

                        <div className="xtable__td xtable__cart-amount">

                            {product.isAvailable && (
                                <>
                                    <div className="xtable__name">
                                        Add extra pictures:
                                    </div>
                                    <AmountInput 
                                        initialValue={product.type === PRODUCT_TYPE.CLIP ? cartItem.additionalPhotoCount : (cartItem.quantity || 1)} 
                                        onChange={(value) => {
                                            updateCartItem({
                                                ...cartItem,
                                                [product.type === PRODUCT_TYPE.CLIP ? 'additionalPhotoCount' : 'quantity']: value
                                            });
                                        }}
                                        minValue={product.type === PRODUCT_TYPE.CLIP ? 0 : 1}
                                    />

                                </>
                            )}

                        </div>

                        { leadTimePrices.length > 1 && <div className="xtable__td">
                            {
                                product.isAvailable && product.type === PRODUCT_TYPE.CLIP &&
                                <div className="xtable__cart-btns">

                                    <LeadTimePriceInput initialValue={cartItem.leadTimePrice} onChange={(value) => {

                                        updateCartItem({
                                            ...cartItem,
                                            leadTimePrice: value.id
                                        });
                                    }} uiVariant="cart"/>

                                </div>
                            }
                        </div>}
                        <div className="xtable__td xtable__cart-upload">

                            {
                                product.type === PRODUCT_TYPE.CLIP &&
                                product.clipProperties &&
                                product.isAvailable &&
                                <button
                                        className="btn btn_cta btn_mds" type="button"
                                        onClick={() => {
                                            setCartItemToUpload(cartItem);
                                        }}
                                        data-counter={cartItem.images.length}>
                                    Upload Your Photos &amp;&nbsp;Add Your Story Title
                                </button>
                            }

                        </div>
                        <div className="xtable__td">


                            <button className="btn-remove" type="button" title="Remove"
                                    onClick={() => {
                                        removeFromCart(cartItem)
                                    }}>

                                <svg role="img" className="btn-remove__ico">
                                    <use href="./img/sprite.svg#remove"></use>
                                </svg>
                            </button>

                        </div>


                    </div>
                })}
            </div>
            {
                cartItemToUpload &&
                productToUpload &&
                productToUpload.clipProperties &&
                <UploadImages cartItem={cartItemToUpload}
                              notabs={true}
                              product={productToUpload as ProductClipType}
                              popup={true}
                              onDone={() => {
                                  setCartItemToUpload(undefined);

                              }}
                              onPopupCloseClick={() => {
                                  setCartItemToUpload(undefined);
                              }}/>
            }
        </>
    )
}